export function ShortPrice(price: number): string {
  // Shorten the price for display in the label (i.e. $1M, $2.4M, $500K)
  // Do not show decimal places if the price is rounded to a whole number (i.e. $1M instead of $1.0M)
  if (price >= 999_500) {
    const _shortPrice = Number((price / 1_000_000).toFixed(1));

    return `$${_shortPrice % 1 === 0 ? _shortPrice.toFixed(0) : _shortPrice.toFixed(1)}M`;
  } else if (price >= 1_000) {
    const _shortPrice = price / 1_000;

    return `$${_shortPrice.toFixed(0)}K`;
  } else {
    return `$${price.toString()}`;
  }
}
